import { useEffect, useState } from "react";
import styles from "./styles.module.css";

type Props = {
  targetEpochSeconds: number; // Unix timestamp in seconds
};

function format(unit: number) {
  return String(unit).padStart(2, "0");
}

export default function CountdownTimer({ targetEpochSeconds }: Props) {
  const [now, setNow] = useState(() => Math.floor(Date.now() / 1000));

  useEffect(() => {
    const id = setInterval(() => setNow(Math.floor(Date.now() / 1000)), 1000);
    return () => clearInterval(id);
  }, []);

  const remaining = Math.max(targetEpochSeconds - now, 0);
  if (!remaining) return null;

  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor((remaining % 3600) / 60);
  const seconds = remaining % 60;

  return (
    <span className={styles.timer}>
      {format(hours)}ч. {format(minutes)}м. {format(seconds)}с.
    </span>
  );
}
